import EmptyResult from 'component/EmptyResult'
import VideoBox from 'component/VideoBox'
import { useImmer } from 'use-immer'
import { fetchVideoHistoryList } from 'api'
import { AreaPanelCmsGridWrapper, InfiniteScrollWrapper, PageScrollWrap } from 'commonStyledComponents'

interface VideoState {
  nextPage: number
  isLoading: boolean
  hasMore: boolean
  list: any[]
  page_result: { current: number | null; pageSize: number | null; total: number | null }
  current?: number
}

const Video = () => {
  const [state, updateState] = useImmer<VideoState>({
    nextPage: 1,
    isLoading: true,
    hasMore: true,
    list: [],

    page_result: { current: null, pageSize: null, total: null },
  })

  const handleFetchVideoList = async () => {
    if (state.current === state.page_result.current || !state.hasMore) return

    const data = {
      current: state.nextPage,
    }

    try {
      const response = await fetchVideoHistoryList(data)
      updateState((draft) => {
        draft.list = draft?.list?.concat(response?.data)
        draft.hasMore = response?.page_result?.total > response?.page_result?.current * response?.page_result?.pageSize
        draft.nextPage = response?.page_result?.current + 1
        draft.page_result = response.page_result

        draft.isLoading = false
      })
    } catch (error) {
      updateState((draft) => {
        draft.isLoading = false
      })
    }
  }

  return !state?.list?.length && !state.isLoading ? (
    <EmptyResult />
  ) : (
    <PageScrollWrap>
      <InfiniteScrollWrapper
        pageStart={0}
        loadMore={handleFetchVideoList}
        hasMore={state?.hasMore}
        // loader={<div className="loader" key={0}>Loading ...</div>}
        useWindow={false}
      >
        {state?.list?.length > 0 && (
          <AreaPanelCmsGridWrapper>
            {state?.list?.map((item, i) => (
              <VideoBox key={i} videoInfo={item}>
                {i}
              </VideoBox>
            ))}
          </AreaPanelCmsGridWrapper>
        )}
      </InfiniteScrollWrapper>
    </PageScrollWrap>
  )
}

export default Video
